export default __webpack_public_path__ + "static/media/prev_page_ico.e2b41fab.svg";